import OffgradesWidgetContainer from "./OffgradesWidgetContainer";
export type { OffgradesApiResponse } from "./Offgrades";

export default OffgradesWidgetContainer;
